import { useQuery } from '@tanstack/react-query';
import { getContext, getTrackEventsContext } from '../services/platformIntegrationService';
import { hasLocalStorageItem } from '../common/utils/utils';
import { QUERIES_KEYS } from '../constant';

export const useContextQuery = () => ({
  ...useQuery({
    queryKey: [QUERIES_KEYS.CONTEXT_QUERY_KEY],
    queryFn: () => getContext(),
    enabled: hasLocalStorageItem('account_id'),
  }),
});

export const useTrackEventsContextQuery = (enabled) => ({
  ...useQuery({
    queryKey: [QUERIES_KEYS.TRACK_EVENTS_CONTEXT_QUERY_KEY],
    queryFn: () => getTrackEventsContext(),
    enabled,
  }),
});
